import { defineComponent as _defineComponent } from 'vue'
import WizardStep from '@/components/wizard/WizardStep.vue';
import SubsidiariesTagInput from '@/components/inputs/SubsidiariesTagInput.vue';
import CustomersTagInput from '@/components/inputs/CustomersTagInput.vue';
import { FormValues, Recipient } from './model';
import { AlertAction } from '@/models/enums/AlertsEnums';
import { computed, watch } from 'vue';
import { required } from '@/utils/validation';
import useVuelidate from '@vuelidate/core';
import { currentUser } from '@/utils/permissionUtils';
import { useI18n } from '@/composables/i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'NotificationRecipientSelectionWizardStep',
  props: {
    value: null,
    isSubsidiaryNotification: { type: Boolean }
  },
  emits: ["input", "switch"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'input', formValues: FormValues): void;
  (e: 'switch', value: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  value: FormValues;
  isSubsidiaryNotification: boolean;
};





const { t } = useI18n();

const recipients = computed({
  get() {
    return props.value.recipients;
  },
  set(newValue) {
    emit('input', {
      ...props.value,
      recipients: newValue,
    });
  },
});

const isSubsidiaryNotificationEnabled = computed({
  get() {
    return props.isSubsidiaryNotification;
  },
  set(newValue) {
    emit('switch', newValue);
  },
});

const sendEmailToAllUsers = computed({
  get() {
    return props.value.sendEmailToAllUsers;
  },
  set(newValue) {
    emit('input', {
      ...props.value,
      sendEmailToAllUsers: newValue,
    });
  },
});

watch(isSubsidiaryNotificationEnabled, () => {
  recipients.value = [];
});

const validations = {
  recipients: {
    required,
  },
};
const v$ = useVuelidate(validations, {
  recipients,
});

function onRecipientTaginputInput(value: Recipient[]) {
  recipients.value = value;
}

const canNotifySubsidiaries = computed(
  (): boolean => currentUser().isGlobalAdmin,
);

return { __sfc: true,props, emit, t, recipients, isSubsidiaryNotificationEnabled, sendEmailToAllUsers, validations, v$, onRecipientTaginputInput, canNotifySubsidiaries, WizardStep, SubsidiariesTagInput, CustomersTagInput, AlertAction }
}

})